import { render, staticRenderFns } from "./ProducersEntity.vue?vue&type=template&id=39e45ce6&"
import script from "./ProducersEntity.vue?vue&type=script&lang=js&"
export * from "./ProducersEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports